import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import VirtualizedAutoComplete from "../../../../../../components/Dropdown/VirtualizedAutocomplete";
import API_BASE_URL from "../../../../../../Constants";

const QuickDispatcher = ({ callNumber, mechanics, updateLog, isDisabled = false }) => {
    const [formData, setFormData] = useState({ assignedTo: null });
    const [openConfirmation, setOpenConfirmation] = useState(false);

    const handleDispatchClick = () => {
        setOpenConfirmation(true);
    };

    const handleConfirmDispatch = async () => {

        setOpenConfirmation(false);

        const response = await fetch(`${API_BASE_URL}/api/callcenter/calllogs/${callNumber}/dispatch`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify(formData.assignedTo),
        });

        const data = await response.json();
        updateLog(data);

    };

    const handleCancelDispatch = () => {
        setOpenConfirmation(false);
    };

    useEffect(() => {
        if (isDisabled) {
            setFormData({ assignedTo: null });
        }
    }, [isDisabled]);

    return (
        <div className="flex flex-col flex-1">

            <div className="flex flex-row items-end space-x-4 space-y-4">
                <VirtualizedAutoComplete
                    options={mechanics}
                    value={formData?.assignedTo || {}}
                    onChange={(e, newValue) => setFormData({ ...formData, assignedTo: newValue })}
                    label="Assign Mechanic"
                    optionKey="mechanicId"
                    optionLabel="email"
                    disabled={isDisabled}

                />
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleDispatchClick}
                    disabled={!formData.assignedTo || isDisabled}
                    style={{}}
                    className="h-10"
                >
                    Dispatch
                </Button>

            </div>
            <Dialog open={openConfirmation} onClose={handleCancelDispatch}>
                <DialogTitle>Confirm Dispatch</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to assign this mechanic to the building? All the incomplete action items would get reassigned as well.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancelDispatch} color="secondary">
                        Cancel
                    </Button>
                    <Button onClick={handleConfirmDispatch} color="primary"
                        disabled={isDisabled}
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

QuickDispatcher.propTypes = {
    callNumber: PropTypes.string.isRequired,
    mechanics: PropTypes.arrayOf(
        PropTypes.shape({
            mechanicId: PropTypes.string.isRequired,
            email: PropTypes.string.isRequired,
        })
    ).isRequired,
    // onDispatch: PropTypes.func.isRequired,
};

export default QuickDispatcher;